import { gql } from '@/__generated__';

export const TournamentPostFormFragment = gql(`
fragment TournamentPostFormFragment on Tournament {
  label
  fields {
    ...TournamentFieldsFragment
  }
}
`);
